module.exports = __webpack_public_path__ + "img/dpunkt.272f8cda.jpg";